<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.role_name" placeholder="请输入角色名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="sysRoleName" label="角色名称"></el-table-column>
            <el-table-column label="角色状态">
                <template slot-scope="scope">
                    {{ scope.row.sysRoleStatus == 1 ? "启用" : "禁用" }}
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="handleClick('button', scope.row)" type="text" size="small">功能按钮</el-button>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="70%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="80px">
                    <el-form-item label="角色名称">
                        <el-input v-model="handleInfo.sysRoleName"></el-input>
                    </el-form-item>
                    <el-form-item label="角色状态">
                        <el-select v-model="handleInfo.sysRoleStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择权限">
                        <el-select v-model="handleInfo.sysRolePermissions" multiple placeholder="请选择"
                            style="width: 100%;">
                            <el-option v-for="item in getPermissions()" :key="'permission' + item.sysPermissionId"
                                :label="item.sysPermissionName" :value="item.sysPermissionId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <div v-if="handle == 'button'" style="display: flex; justify-content: center;">
                <el-transfer class="button-transfer" v-model="buttonChecked" :data="buttons" :titles="['可选择的功能按钮', '已选择的功能按钮']"></el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet, doPatch } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            roleId: "",
            buttonChecked: [],
            buttons: [],
            permissions: []
        }
    },
    methods: {
        getButtons: async function () {
            let roleButtons = await doGet(API.ROLE_BUTTON, {
                roleId: this.roleId
            });
            if (roleButtons) {
                for (let i = 0; i < roleButtons.length; i++) {
                    this.buttons.push({
                        key: roleButtons[i].sysPermissionButtonId,
                        label: roleButtons[i].sysPermissionName + "：" + roleButtons[i].sysPermissionButtonName
                    });
                }
            }
            console.log("this.buttons={}", this.buttons);
        },
        getPermissions: function () {
            return this.permissions.filter(item => item.sysPermissionUrl != '#');
        },
        beforeHandleSubmit: async function () {
            if (this.handle == "button") {
                let resultObj = await doPatch("/" + this.pageMap.code, {
                    "sys_role_id": this.roleId,
                    "sys_role_permission_buttons": this.buttonChecked.join(",")
                });
                this.showResult(resultObj);
            }
            else {
                this.handleInfo.sysRolePermissions = this.handleInfo.sysRolePermissions.join(",");
            }
        },
        beforeHandleOpen: function () {
            if (this.handleInfo.sysRolePermissions) {
                let arr = this.handleInfo.sysRolePermissions.split(',');
                this.handleInfo.sysRolePermissions = arr;
            }
        },
        beforeHandleOpenEx: async function (handle, info, customer) {
            this.roleId = info.sysRoleId;
            if (handle == "button") {
                if (info.sysRolePermissionButtons) {
                    this.buttonChecked = info.sysRolePermissionButtons.split(',');
                }
                else {
                    this.buttonChecked = [];
                }
                this.getButtons();
            }
        }
    },
    created: async function () {
        this.permissions = await doGet("/sysPermission" + API.ALL);
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";

.button-transfer {
    ::v-deep .el-transfer-panel {
        width: 350px;
    }

    ::v-deep .el-transfer-panel__list.is-filterable {
        height: 500px;
    }
}
</style>